export default "<ion-list  class=\"ion-no-padding\">\n  <ng-content></ng-content>\n</ion-list>\n";